export const MAX_NOTE_LENGTH = 255;
